<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper align-items-center">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">Trinka AI Apps</h1>
                        <h2>あらゆるコンテンツ要件に対応するアプリプラットフォーム</h2>
                        <ul class="bullet-list">
                            <li>コンテンツを瞬時に生成</li>
                            <li>あらゆるケースに対応するAIアプリ</li>
                            <li>特定の分野やニーズに合わせた<br/>カスタマイズも可能</li>
                            <li>高度な機能</li>
                            <li>高度なプロンプトエンジニアリング</li>
                            <li>複数のLLMオプション</li>
                        </ul>
                    </div>
                    <div class="top-banner-right">
                        <div class="enterprise-form" id="OrganizationType">
                            <div class="contact_us_form" *ngIf="formSection">
                                <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()" class="DataSensitiveForm">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('NatureBusinessType').valid && contactForm.get('NatureBusinessType').dirty) || (contactForm.get('NatureBusinessType').touched && contactForm.get('NatureBusinessType').pristine) ? 'TextFiledError' : '' ">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>機関種名（例）「研究機関」「出版社」など*</mat-label>
                                                    <input matInput placeholder="" formControlName="NatureBusinessType" class="form-control">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormSubjects').valid && contactForm.get('contactFormSubjects').dirty) || (contactForm.get('contactFormSubjects').touched && contactForm.get('contactFormSubjects').pristine) ? 'TextFiledError' : '' ">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>ご所属先名*</mat-label>
                                                    <input matInput placeholder="" formControlName="contactFormSubjects" class="form-control">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="textbox_content form-group textareaBox" [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                                <label for="">お問い合わせ内容やご要望の詳細をご入力ください*</label>
                                                <textarea formControlName="contactFormMessage" class="form-control" placeholder="（例）利用予定人数、1か月あたりの利用単語数の目処、カスタマイズのご要望など"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>お名前*</mat-label>
                                                    <input matInput placeholder="" formControlName="contactFormName" class="form-control">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('DesignationTypes').valid && contactForm.get('DesignationTypes').dirty) || (contactForm.get('DesignationTypes').touched && contactForm.get('DesignationTypes').pristine) ? 'TextFiledError' : '' ">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>役職*</mat-label>
                                                    <input matInput placeholder="" formControlName="DesignationTypes" class="form-control">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>メールアドレス*</mat-label>
                                                    <input matInput placeholder="" formControlName="contactFormEmail" class="form-control">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactphoneNo').valid && contactForm.get('contactphoneNo').dirty) || (contactForm.get('contactphoneNo').touched && contactForm.get('contactphoneNo').pristine) ? 'TextFiledError' : '' ">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>連絡先電話番号（国番号 日本は+81もご入力ください）</mat-label>
                                                    <input type="number" matInput placeholder="" formControlName="contactphoneNo" class="form-control">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group text-center">
                                        <button type="submit" [disabled]="isSubmitting">送信する</button>
                                    </div>
                                </form>
                            </div>
                            <div class="thank_section contact_us_form" *ngIf="thankSection">
                                <div class="form-group">
                                    <h2>ありがとうございます。</h2>
                                    <p>週末を除き48時間以内に担当者よりご連絡いたします。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd bg-light-purple list-wrapper-style-2" style="background-color: #FBF6FF;">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title text-center mb-0">
                    <h2>Trinkaと専門家によるチェックの融合のメリット</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div class="list-wrapper-content-2 list-style-cards bt-none text-center pr-0">
                            <div class="features_cards_icon">
                                <img src="https://www.trinka.ai/jp/assets/images/post-event/cost-reduction.png" alt="Cost Reduction" srcset="">
                            </div>
                            <div class="features_cards_desc">
                                <h3>コスト削減 <br class="d-lg-block d-none"/> （5分の1）</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div class="list-wrapper-content-2 list-style-cards text-center bl-1 pr-0">
                            <div class="features_cards_icon">
                                <img src="https://www.trinka.ai/jp/assets/images/post-event/improved-efficiency.png" alt="mproved Efficiency" srcset="">
                            </div>
                            <div class="features_cards_desc">
                                <h3>時間短縮<br/> （10分の1）</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div class="list-wrapper-content-2 list-style-cards bl-1 text-center pr-0">
                            <div class="features_cards_icon">
                                <img src="https://www.trinka.ai/jp/assets/images/post-event/growth-report.png" alt="Enhanced Research Visibility" srcset="">
                            </div>
                            <div class="features_cards_desc">
                                <h3>学術専門家による<br/>
                                    最終チェック</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div class="list-wrapper-content-2 list-style-cards bl-1 text-center pr-0">
                            <div class="features_cards_icon">
                                <img src="https://www.trinka.ai/jp/assets/images/post-event/security.png" alt="Data Privacy" srcset="">
                            </div>
                            <div class="features_cards_desc">
                                <h3>厳重な<br/>
                                    データセキュリティ</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</section>